.graphContainer{
    padding: 35px;
    border-radius: 9px;
    background-color: var(--hps-white);
    box-shadow: 0 0 4px 1px rgba(0,0,0,0.1);
}

.mainGraph{
    margin: 15px;
}
